import React, { useContext } from "react";

//functions
import {
  _t,
  getSystemSettings,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import { SettingsContext } from "../../../../../contexts/Settings";
import "./stock.css"

const FgInvoicePrint = ({
  name,
  FgPrint,
  newItem,
  newRow,
  invoiceNo,
  inoviceDate
}) => {
  const { t } = useTranslation();
  const {
    //common
    generalSettings,
  } = useContext(SettingsContext);

  return (
    
    <>
      {/* print */}
      <div className="d-none">
        <div ref={FgPrint}>
          {newItem && (
            <div className="fk-print" style={{margin:"20px"}}>
              <div>
                <div className="row">
                  <div className="col-12">
                    <div className="mx-auto" style={{ width: "90px" }}>
                      <img
                        src={`${getSystemSettings(
                          generalSettings,
                          "type_logo"
                        )}`}
                        style={{ width: "100%" }}
                      />
                    </div>
                    <div className="my-2 lg-text print-text-stock text-center text-capitalize print-text-stock--bold">
                      {newItem.branch && newItem.branch?.name}
                    </div>
                    <div className="my-2 lg-text print-text-stock text-center text-capitalize print-text-stock--bold">
                      {name}
                    </div>

                    <div className="mt-4 my-2 print-text-stock row text-capitalize ml-0">
                      <div className="col-6 print-text-stock--bold">{invoiceNo}: {newItem?.invoice}</div>
                      <div className="col-6 print-text-stock--bold">{inoviceDate} : {newItem?.date && newItem?.date?.toDateString()}</div>
                    </div>
                    
                    <div className="my-2 ml-0 print-text-stock text-capitalize print-text-stock--bold row">
                      {newItem.customer ? 
                        <div className="col-6 print-text-stock--bold">
                          Customer Name :{" "}
                          {newItem.customer && newItem.customer.name}
                        </div> : ""
                      }
                      {newItem?.paymentType ?
                      <div className="col-6 print-text-stock--bold">
                        Payment Type :{" "}
                        {newItem.paymentType}
                      </div> : ""}
                    </div> 

                    {newItem.description ? (
                      <div className="my-2 ml-0 print-text-stock print-text-stock--bold text-capitalize row">
                        {newItem.description ?
                          <div className="col-6 print-text-stock--bold">
                            Description :{" "}
                            {newItem.description && newItem.description}
                          </div> : ""
                        }
                      </div>
                      ) : ""
                    }

                    {
                      newItem?.paid_amount && (
                        <div className="mb-3 my-2 print-text-stock print-text-stock--bold text-capitalize">
                          <div className="print-text-stock--bold">
                            Paid Amount :{" "}
                            {newItem.paid_amount}
                          </div>
                        </div>
                      )
                    }
                    <div>
                    </div>
                    
                    {newRow !== null && [
                      newRow.length > 0 && (
                        <div className=" mt-3">
                          <table className="table table-bordered-sm table-hover ">
                            <thead className="align-middle">
                              <tr>
                                <th
                                  scope="col"
                                  className="print-text-stock text-capitalize align-middle text-center border-dark border-1 border table-Child"
                                >
                                  {_t(t("Name"))}
                                </th>
                                
                                <th
                                  scope="col"
                                  className="print-text-stock text-capitalize align-middle text-center border-dark border-1 border"
                                >
                                  {_t(t("Qty"))}
                                </th>

                                <th
                                  scope="col"
                                  className="print-text-stock text-capitalize align-middle text-center border-dark border-1 border"
                                >
                                  {_t(t("Rate"))}
                                </th>

                                <th
                                  scope="col"
                                  className="print-text-stock text-capitalize align-middle text-center border-dark border-1 border"
                                >
                                {_t(t("Amount"))}
                                </th>
                                {
                                  newRow[0]?.total && (
                                    <th
                                      scope="col"
                                      className="print-text-stock text-capitalize align-middle text-center border-dark border-1 border"
                                    >
                                      {_t(t("Total"))}
                                    </th>
                                  )
                                }
                                
                              </tr>
                            </thead>

                            <tbody className="align-middle">
                              {newRow?.map((ingredientItem, index) => {

                                return (
                                  <tr className="align-middle" key={index}>
                                    <td className="print-text-stock text-capitalize border-dark border-1 align-middle text-center">
                                      {ingredientItem.ingredient_name}
                                    </td>

                                    <td className="print-text-stock text-capitalize border-dark border-1 align-middle text-center">
                                      {ingredientItem.qty}
                                    </td>

                                    <td className="print-text-stock text-capitalize border-dark border-1 align-middle text-center">
                                      {ingredientItem.rate ?? ingredientItem.price}
                                    </td>

                                    <td className="print-text-stock text-capitalize border-dark border-1 align-middle text-center">                                     
                                      {ingredientItem?.amount ?? 0}
                                    </td>
                                    
                                    {
                                      ingredientItem?.total && (
                                        <td className="print-text-stock text-capitalize border-dark border-1 align-middle text-center">                                     
                                          {ingredientItem?.total ?? 0}
                                        </td>
                                      )
                                    }
                                    
                                  </tr>
                                );
                              })}
                              
                            </tbody>
                            
                            <tbody className="align-middle">
                              {newItem?.total_amount && (
                                <tr>
                                  <th
                                    scope="col"
                                    colSpan={!newRow[0]?.total ? 2 : 3}
                                    className="print-text-stock text-capitalize align-middle text-center border-dark border-1 border"
                                  ></th>
                                  <th
                                    scope="col"
                                    className="print-text-stock text-capitalize align-middle text-center border-dark border-1 border"
                                  >
                                    {_t(t("Net Amount"))}
                                  </th>
                          
                                  <th
                                    scope="col"
                                    className="print-text-stock text-capitalize align-middle text-center border-dark border-1 border"
                                  >
                                    {newItem && newItem?.total_amount &&
                                    parseFloat(newItem?.total_amount).toFixed(2)
                                    }
                                  </th>
                                </tr>
                              )}
                              {newItem?.total_discount && (
                                <tr>
                                  <th
                                  scope="col"
                                  colSpan={!newRow[0]?.total ? 2 : 3}
                                  className="print-text-stock text-capitalize align-middle text-center border-dark border-1 border"
                                  ></th>
                                  <th
                                  scope="col"
                                  className="print-text-stock text-capitalize align-middle text-center border-dark border-1 border"
                                >
                                  {_t(t("Discount amount"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="print-text-stock text-capitalize align-middle text-center border-dark border-1 border"
                                  >
                                    {newItem && newItem?.total_discount &&
                                    parseFloat(newItem?.total_discount).toFixed(2)}
                                  </th>
                                </tr>
                              )}
                              {newItem?.total_tax && (
                                <tr>
                                  <th
                                    scope="col"
                                    colSpan={!newRow[0]?.total ? 2 : 3}
                                    className="print-text-stock text-capitalize align-middle text-center border-dark border-1 border"
                                  ></th>
                                    <th
                                    scope="col"
                                    className="print-text-stock text-capitalize align-middle text-center border-dark border-1 border"
                                  >
                                    {_t(t("Tax amount"))}
                                  </th>
                                  <th
                                  scope="col"
                                  className="print-text-stock text-capitalize align-middle text-center border-dark border-1 border"
                                  >
                                    {newItem && newItem?.total_tax && parseFloat(newItem?.total_tax).toFixed(2)}
                                  </th>
                                </tr>
                              )}
                              {newItem?.total_bill && (
                              <tr>
                                <th
                                scope="col"
                                colSpan={!newRow[0]?.total ? 2 : 3}
                                className="print-text-stock text-capitalize align-middle text-center border-dark border-1 border"
                                ></th>
                                <th
                                scope="col"
                                className="print-text-stock text-capitalize align-middle text-center border-dark border-1 border"
                                >
                                {_t(t("Total amount"))}
                                </th>

                                <th
                                  scope="col"
                                  className="print-text-stock text-capitalize align-middle text-center border-dark border-1 border"
                                >
                                  {newItem &&
                                  newItem?.total_bill}
                                </th>
                              </tr>
                              )}
                              {newItem?.net_total && (
                                <tr>
                                  <th
                                    scope="col"
                                    colSpan={!newRow[0]?.total ? 2 : 3}
                                    className="print-text-stock text-capitalize align-middle text-center border-dark border-1 border"
                                  ></th>
                                    <th
                                    scope="col"
                                    className="print-text-stock text-capitalize align-middle text-center border-dark border-1 border"
                                  >
                                    {_t(t("Net Total"))}
                                  </th>
                                  <th
                                  scope="col"
                                  className="print-text-stock text-capitalize align-middle text-center border-dark border-1 border"
                                  >
                                    {newItem.net_total}
                                  </th>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      ),
                    ]}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default FgInvoicePrint
